import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

type GetAgentJobArgsType = GetRequestArgsType & {
  agentJobId: string;
};

type CancelAgentJobArgsType = PostRequestArgsType<Record<string, never>> & {
  agentJobId: string;
};

export const apiFetchAgentJob = async ({
  domain = useTenantStore().domain,
  agentJobId,
  errorConfig = {},
  callbacks = {},
}: GetAgentJobArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.agentJobs({ domain, agentJobId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCancelAgentJob = async ({
  domain = useTenantStore().domain,
  agentJobId,
  payload = {},
  errorConfig = {},
  callbacks = {},
}: CancelAgentJobArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.cancelAgentJob({ domain, agentJobId }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
